import script from "./customTable.vue?vue&type=script&setup=true&lang=js"
export * from "./customTable.vue?vue&type=script&setup=true&lang=js"

import "./customTable.vue?vue&type=style&index=0&id=c1608b3a&lang=css"
import "./customTable.vue?vue&type=style&index=1&id=c1608b3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1608b3a"]])

export default __exports__